module.exports = __webpack_public_path__ + "pc/img/erCode1.b70bb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom/erCode1.jpg
// module id = pypQ
// module chunks = 3